module.exports = __webpack_public_path__ + "img/leichtesfruehstueck.8a95fb3a.png";